var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCancel = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-236 -3432)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(236 3432)",
    fill: "rgba(0,0,0,0)",
    opacity: 0.871
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon",
    d: "M248,3454a10,10,0,1,1,10-10A10.012,10.012,0,0,1,248,3454Zm0-18a8,8,0,1,0,8,8A8.009,8.009,0,0,0,248,3436Zm-3.591,13h0L243,3447.59l3.59-3.59-3.59-3.59,1.41-1.409,3.59,3.589L251.59,3439l1.41,1.409-3.59,3.59,3.59,3.59-1.41,1.41-3.59-3.59-3.59,3.59Z",
    fill: "#1d1d1d"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCancel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cancel.18c8262b.svg";
export { ForwardRef as ReactComponent };